<template>
    <vs-prompt
        title="Assign Goal(s) To Month"
        accept-text="Add"
        button-cancel="border"
        @cancel="close"
        @accept="save"
        @close="close"
        :is-valid="validateForm"
        :active="promptActive"
    >
        <label for="goals" class="vs-input--label block text-sm">
          Goals
        </label>
        <multi-select
            v-model="goalsPlaceholder"
            :multiple="true"
            v-validate="'required'"
            data-vv-name="goals"
            id="goals"
            :options="goalsOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            label="label"
            placeholder="Select Goals"
            track-by="id"
            class="w-full"
            @input="selectGoals"
        />
        <label v-if="errors.has('goals')" class="text-danger text-sm">
            {{ errors.first('goals') }}
        </label>

        <MonthSelect
            v-model="period"
            v-validate="'required'"
            data-vv-name="month"
            label="Month"
            class="w-full my-5"
        />
        <label v-if="errors.has('month')" class="text-danger text-sm">
            {{ errors.first('month') }}
        </label>
    </vs-prompt>
</template>
<script>
import _ from 'lodash'
import MonthSelect from '../Generic/MonthSelect'

export default {
  components: {
    MonthSelect,
  },
  props: {
    promptActive: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    currentPeriod: {
      type: [Date, String],
      required: true,
    }
  },
  data () {
    return {
      goals: [],
      goalsPlaceholder: [],
      period: this.currentPeriod,
    }
  },
  watch: {
    currentPeriod: {
      immediate: true,
      async handler (currentPeriod) {
        this.clearSelect()
        this.period = currentPeriod
      }
    }
  },
  computed: {
    goalsOptions () {
      return _.map(this.$store.getters.goalsWithoutPeriod, (goal) => Object.assign({}, {
        label: this.title(goal),
        id: goal.id
      }))
    },
    goalsPresent () {
      return !_.isEmpty(this.goalsOptions)
    },
    validateForm () {
      return !this.errors.any()
    },
  },
  methods: {
    clearSelect () {
      this.goals = []
      this.goalsPlaceholder = []
    },
    selectGoals (goals) {
      this.goals = _.filter(this.$store.getters.goalsWithoutPeriod, (goal) => {
        return _.find(goals, { id: goal.id })
      })
    },
    title (goal) {
      const dream = this.$store.getters.dreamsById[goal.dreamId]
      return _.chain([_.get(goal, 'title'), _.get(dream, 'title')])
        .reject((x) => !x)
        .join(' - ')
        .value()
    },
    async close () {
      await this.$validator.pause()
      this.clearSelect()
      await this.$validator.resume()
      this.$emit('close')
    },
    save () {
      this.$validator.validateAll().then((result) => {
        if (!result) return

        _.each(this.goals, async (goal) => {
          goal.period = this.period
          goal.orderPlan = 999
          await this.$store.dispatch('UPDATE_GOAL', { goal })
        })

        this.clearSelect()
        this.close()
      })
    },
  }
}
</script>
